import { createSelector } from '@reduxjs/toolkit';

import { AttachingMethod } from '../../../types';
import { selectAttachedFiles } from '../../common/selectors/attaches';
import { attachingMethodMapper } from '../types';
import { getAttachmentBi } from '../utils';

export const selectAttachmentsBiData = createSelector(selectAttachedFiles, (attachedFiles) => {
  const attachingMethod = {
    [attachingMethodMapper[AttachingMethod.Button]]: 0,
    [attachingMethodMapper[AttachingMethod.Drop]]: 0,
    [attachingMethodMapper[AttachingMethod.Paste]]: 0,
  };

  attachedFiles.forEach(
    (file) =>
      // TODO: remove undefined checking when attachments are updated in session
      // for now it's possible to click on "Change" button and attachments state will be incorrect
      file.attachingMethod !== undefined && attachingMethod[attachingMethodMapper[file.attachingMethod]]++,
  );

  return {
    attachingMethod,
    attachmentsLength: attachedFiles.length,
    attachments: getAttachmentBi(attachedFiles),
  };
});
